import { Client } from './client';

export class OrderBilling {
  client: Client = null;
  businessName: string = null;
}
